/* ag-ux-cart v1 — cart behavior enhancements.
   Scope of the offline block below, deliberately:
   - Observes ONLY native navigator connectivity events. No fetch wrapping,
     no cart-endpoint interception, no checkout-path code (banned territory).
   - If anything here throws, it degrades to nothing; the store is untouched.
   R13's separately guarded coupon block uses Shopify's official Ajax Cart
   endpoints directly; it does not intercept or change checkout navigation.
   Removal: delete this file + its <script> tag in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__agUxcOffline) return;
  window.__agUxcOffline = true;

  var el = null;

  function ensureEl() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'aguxc-offline';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M2 8.8a15 15 0 0 1 20 0"/><path d="M5.5 12.5a10 10 0 0 1 13 0"/>' +
      '<path d="M9 16.2a5 5 0 0 1 6 0"/><circle cx="12" cy="19.5" r="0.6" fill="currentColor"/></svg>' +
      '<span>You&rsquo;re offline. Your cart is safe, so reconnect to continue.</span>';
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function show() {
    try {
      var node = ensureEl();
      // rAF so display:flex lands before the opacity/transform transition starts
      requestAnimationFrame(function () { node.classList.add('is-visible'); });
    } catch (e) { /* never let this surface break the page */ }
  }

  function hide() {
    if (!el) return;
    el.classList.remove('is-visible');
  }

  // Initial state: someone can load the tab already offline.
  if (navigator.onLine === false) show();
  window.addEventListener('offline', show);
  window.addEventListener('online', hide);
})();

/* ------------------------------------------------------------------ *
   R13 B2: keep cart navigation in the drawer when the drawer is usable.

   Every cart affordance keeps its real /cart href. This delegated handler
   prevents navigation only after Minimog has synchronously exposed the
   drawer. A direct /cart visit deliberately hands off to the storefront
   home, waits for Minimog, and opens the drawer. If that cannot happen in
   four seconds, ag_cart_fallback=1 leaves the working cart page in place.

   Shared contract for separately owned UI (including the add-on sheet):
     window.ArmourCartDrawer.open(clickEvent)
     document.dispatchEvent(new CustomEvent('ag:cart-drawer:open'))
   Normal <a href="/cart"> links need no extra attribute.                 */
(function () {
  'use strict';
  if (window.__agCartDrawerNavigation) return;
  window.__agCartDrawerNavigation = true;

  var handoffKey = 'ag-cart-drawer-handoff';
  var handoffParam = 'ag_open_cart';
  var fallbackParam = 'ag_cart_fallback';

  function cartController() {
    return window.MinimogTheme && window.MinimogTheme.Cart;
  }

  function drawerNodes() {
    return {
      wrapper: document.querySelector('.scd__wrapper'),
      panel: document.querySelector('.scd__content')
    };
  }

  function isOpen(nodes) {
    return !!(nodes.wrapper && nodes.panel &&
      !nodes.wrapper.classList.contains('hidden') &&
      !nodes.panel.classList.contains('translate-x-full'));
  }

  function canOpen() {
    var controller = cartController();
    var nodes = drawerNodes();
    return !!(controller && typeof controller.openCartDrawer === 'function' &&
      !controller.isCartPage && controller.enableCartDrawer !== false &&
      nodes.wrapper && nodes.panel);
  }

  function openDrawer(triggerEvent) {
    if (!canOpen()) return false;
    var nodes = drawerNodes();
    if (!isOpen(nodes)) {
      try {
        /* Do not pass the click yet: Minimog prevents it before proving that
           usable drawer nodes exist. We own the fallback decision here. */
        cartController().openCartDrawer();
      } catch (error) {
        return false;
      }
    }
    if (nodes.wrapper.classList.contains('hidden')) return false;
    if (triggerEvent && typeof triggerEvent.preventDefault === 'function') {
      triggerEvent.preventDefault();
    }
    return true;
  }

  function cartPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try { return new URL(root + 'cart', window.location.origin).pathname.replace(/\/$/, ''); }
    catch (error) { return '/cart'; }
  }

  function isCartLink(link) {
    if (!link || link.hasAttribute('download')) return false;
    if (link.target && link.target.toLowerCase() !== '_self') return false;
    try {
      var url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin &&
        url.pathname.replace(/\/$/, '') === cartPath();
    } catch (error) {
      return false;
    }
  }

  function storageGet() {
    try { return window.sessionStorage.getItem(handoffKey); }
    catch (error) { return null; }
  }

  function storageSet(value) {
    try {
      if (value) window.sessionStorage.setItem(handoffKey, value);
      else window.sessionStorage.removeItem(handoffKey);
    } catch (error) {}
  }

  function currentUrl() {
    try { return new URL(window.location.href); }
    catch (error) { return null; }
  }

  function copyPreviewContext(from, to) {
    if (!from || !to) return;
    ['preview_theme_id', 'pb'].forEach(function (name) {
      if (from.searchParams.has(name) && !to.searchParams.has(name)) {
        to.searchParams.set(name, from.searchParams.get(name));
      }
    });
  }

  function cartFallbackUrl() {
    var current = currentUrl();
    var fallback = new URL(cartPath() || '/cart', window.location.origin);
    fallback.searchParams.set(fallbackParam, '1');
    copyPreviewContext(current, fallback);
    return fallback.href;
  }

  function returnTarget() {
    var current = currentUrl();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var target = new URL(root, window.location.origin);
    copyPreviewContext(current, target);
    target.searchParams.set(handoffParam, '1');
    return target;
  }

  function redirectCartPageToDrawer() {
    var url = currentUrl();
    if (!url || url.pathname.replace(/\/$/, '') !== cartPath() ||
        url.searchParams.get(fallbackParam) === '1') return false;
    storageSet('1');
    window.location.replace(returnTarget().href);
    return true;
  }

  function clearHandoffUrl() {
    var url = currentUrl();
    if (!url || !url.searchParams.has(handoffParam)) return;
    url.searchParams.delete(handoffParam);
    try { window.history.replaceState(window.history.state, '', url.href); }
    catch (error) {}
  }

  function completeCartHandoff() {
    var url = currentUrl();
    var requested = storageGet() === '1' || !!(url && url.searchParams.get(handoffParam) === '1');
    if (!requested) return;
    var started = Date.now();

    function attempt() {
      if (openDrawer()) {
        storageSet('');
        clearHandoffUrl();
        return;
      }
      if (Date.now() - started < 4000) {
        window.setTimeout(attempt, 100);
        return;
      }
      storageSet('');
      window.location.replace(cartFallbackUrl());
    }

    attempt();
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!isCartLink(link)) return;
    openDrawer(event);
  });

  document.addEventListener('ag:cart-drawer:open', function (event) {
    openDrawer(event);
  });

  window.ArmourCartDrawer = {
    open: openDrawer,
    canOpen: canOpen
  };

  if (!redirectCartPageToDrawer()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', completeCartHandoff, { once: true });
    } else {
      completeCartHandoff();
    }
  }
})();

/* ------------------------------------------------------------------ *
   R13 W5: web-native modal behavior for the one shared cart drawer.

   Minimog already owns rendering, opening, closing, and cart refreshes. This
   layer adds the interaction contract its mobile drawer omitted: Escape,
   focus containment/restoration, and a right-swipe dismiss from the panel's
   leading edge. It never creates a second cart UI or touches cart endpoints.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agCartDrawerA11yW5) return;
  window.__agCartDrawerA11yW5 = true;

  var wrapper = null;
  var panel = null;
  var stateObserver = null;
  var bootObserver = null;
  var wasOpen = false;
  var restoreFocus = null;
  var drag = null;

  function drawerIsOpen() {
    return !!(wrapper && panel &&
      !wrapper.classList.contains('hidden') &&
      !panel.classList.contains('translate-x-full'));
  }

  function focusableNodes() {
    if (!panel) return [];
    var selector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(panel.querySelectorAll(selector), function (node) {
      return !node.hidden && node.getAttribute('aria-hidden') !== 'true' &&
        window.getComputedStyle(node).display !== 'none' && node.getClientRects().length > 0;
    });
  }

  function closeDrawer() {
    var controller = window.MinimogTheme && window.MinimogTheme.Cart;
    if (controller && typeof controller.closeCartDrawer === 'function') {
      controller.closeCartDrawer();
      return;
    }
    if (!wrapper || !panel) return;
    panel.classList.add('translate-x-full');
    window.setTimeout(function () {
      wrapper.classList.add('hidden');
      wrapper.classList.remove('mobile');
      document.documentElement.classList.remove('prevent-scroll');
    }, 200);
  }

  function syncModalState() {
    var open = drawerIsOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      restoreFocus = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
      panel.setAttribute('aria-hidden', 'false');
      if (window.innerWidth < 770) document.documentElement.classList.add('prevent-scroll');
      window.requestAnimationFrame(function () {
        var close = panel && panel.querySelector('.scd__close');
        if (drawerIsOpen() && close) close.focus({ preventScroll: true });
      });
      return;
    }
    if (panel) panel.setAttribute('aria-hidden', 'true');
    if (restoreFocus && document.contains(restoreFocus) && typeof restoreFocus.focus === 'function') {
      restoreFocus.focus({ preventScroll: true });
    }
    restoreFocus = null;
  }

  function onKeydown(event) {
    if (event.defaultPrevented || !drawerIsOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    var nodes = focusableNodes();
    if (!nodes.length) {
      event.preventDefault();
      panel.focus({ preventScroll: true });
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function onPointerDown(event) {
    if (!drawerIsOpen() || window.innerWidth >= 770 ||
        (event.pointerType && event.pointerType !== 'touch' && event.pointerType !== 'pen')) return;
    var rect = panel.getBoundingClientRect();
    if (event.clientX - rect.left > 56) return;
    if (event.target.closest('a,button,input,select,textarea,[role="button"],.ag-xs2-track,.ag-cart-xsell__track,.ag-cart-offers__track')) return;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, dy: 0 };
    wrapper.classList.add('ag-cart-drawer--dragging');
    try { panel.setPointerCapture(event.pointerId); } catch (error) {}
  }

  function onPointerMove(event) {
    if (!drag || event.pointerId !== drag.id) return;
    drag.dx = Math.max(0, event.clientX - drag.x);
    drag.dy = event.clientY - drag.y;
    if (drag.dx <= Math.abs(drag.dy)) return;
    event.preventDefault();
    panel.style.transform = 'translate3d(' + drag.dx + 'px,0,0)';
  }

  function finishPointer(event, cancelled) {
    if (!drag || event.pointerId !== drag.id) return;
    var shouldClose = !cancelled && drag.dx > Math.max(72, panel.offsetWidth * 0.2) &&
      drag.dx > Math.abs(drag.dy) * 1.2;
    drag = null;
    wrapper.classList.remove('ag-cart-drawer--dragging');
    if (shouldClose) {
      closeDrawer();
      window.requestAnimationFrame(function () { if (panel) panel.style.transform = ''; });
    } else {
      panel.style.transform = '';
    }
  }

  function bindDrawer() {
    var nextWrapper = document.querySelector('.ag-cart-drawer');
    var nextPanel = nextWrapper && nextWrapper.querySelector('.scd__content');
    if (!nextWrapper || !nextPanel) return;
    if (bootObserver) {
      bootObserver.disconnect();
      bootObserver = null;
    }
    if (wrapper === nextWrapper && panel === nextPanel) {
      syncModalState();
      return;
    }
    if (stateObserver) stateObserver.disconnect();
    wrapper = nextWrapper;
    panel = nextPanel;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    var title = panel.querySelector('.ag-cart-title');
    if (title) {
      if (!title.id) title.id = 'ag-cart-drawer-title';
      panel.setAttribute('aria-labelledby', title.id);
    } else {
      panel.setAttribute('aria-label', 'Your cart');
    }
    panel.setAttribute('tabindex', '-1');
    panel.setAttribute('aria-hidden', drawerIsOpen() ? 'false' : 'true');
    panel.addEventListener('pointerdown', onPointerDown);
    panel.addEventListener('pointermove', onPointerMove);
    panel.addEventListener('pointerup', function (event) { finishPointer(event, false); });
    panel.addEventListener('pointercancel', function (event) { finishPointer(event, true); });
    stateObserver = new MutationObserver(syncModalState);
    stateObserver.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    stateObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
    syncModalState();
  }

  function start() {
    bindDrawer();
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('cart:refresh', bindDrawer);
    document.addEventListener('cart:updated', bindDrawer);
    if (window.MinimogEvents && typeof window.MinimogEvents.on === 'function') {
      window.MinimogEvents.on('ON_OPEN_DRAWER_CART', bindDrawer);
    }
    if (document.body && !wrapper) {
      bootObserver = new MutationObserver(bindDrawer);
      bootObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ------------------------------------------------------------------ *
   R5-B4 additions — same safety rules as above:
   - names/labels + a visual "this number changed" cue only;
   - no cart-endpoint calls, no interception, no checkout-path code.
   Removal: delete this block. Styles: ag-ux-r5-B4-CART.css §3.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agUxcR5) return;
  window.__agUxcR5 = true;

  // Quantity inputs ship with no accessible name on both surfaces
  // (<input type="number" class="scd-item__qty_input">). Name them.
  function labelQtyInputs(root) {
    var nodes = (root || document).querySelectorAll('.scd-item__qty_input:not([aria-label])');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('aria-label', 'Quantity');
      nodes[i].setAttribute('inputmode', 'numeric');
    }
  }

  // Immediate feedback when the total figure changes (drawer re-renders and
  // /cart AJAX updates both land here via DOM mutation, so we never touch or
  // depend on cart endpoints ourselves).
  function flash(el) {
    if (!el || prefersReduced()) return;
    el.classList.remove('aguxc-flash');
    // restart the animation even when the text is unchanged-and-changed-back
    void el.offsetWidth;
    el.classList.add('aguxc-flash');
    setTimeout(function () { el.classList.remove('aguxc-flash'); }, 400);
  }
  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function observeTotals(root) {
    var totals = (root || document).querySelectorAll('[data-cart-subtotal-price]');
    for (var i = 0; i < totals.length; i++) {
      if (totals[i].__agUxcWatched) continue;
      totals[i].__agUxcWatched = true;
      try {
        var obs = new MutationObserver(function (m) { flash(m[0].target); });
        obs.observe(totals[i], { childList: true, characterData: true, subtree: true });
      } catch (e2) {}
    }
  }

  function run() { labelQtyInputs(document); observeTotals(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // drawer re-render / AJAX line-item updates replace these nodes
  document.addEventListener('cart:updated', run);
  document.addEventListener('cart:refresh', run);
})();

/* ------------------------------------------------------------------ *
   R5-Q4 additions — same safety rules as above:
   - The theme's cart notifications (.notification, app.js Notification
     class) are VISUAL ONLY and auto-hide in 3s: screen readers never
     hear "item added", and a failed quantity change is invisible to
     anyone not looking at the exact pixel at the exact moment.
   - We OBSERVE those nodes and mirror their message into proper
     aria-live regions. We do not modify, delay or suppress them.
   - One narrow fetch OBSERVER wraps window.fetch purely to READ the
     response status of POST /cart/add.js: the frozen theme-level
     upsell handler (layout/theme.liquid #ag-upsell-add-global)
     swallows failures silently (button text reverts, nothing else),
     so an out-of-stock add is otherwise indistinguishable from
     success. The wrapper never alters requests or responses.
   Removal: delete this block.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agUxcNotiMirror) return;
  window.__agUxcNotiMirror = true;

  var SR_STYLE = 'position:absolute!important;width:1px;height:1px;' +
    'margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
  var polite = null, assertive = null;

  function region(live) {
    var el = document.createElement('div');
    el.className = 'aguxc-sr';
    el.setAttribute('aria-live', live);
    el.setAttribute('role', live === 'assertive' ? 'alert' : 'status');
    el.style.cssText = SR_STYLE;
    document.body.appendChild(el);
    return el;
  }

  function announce(text, urgent) {
    if (!text) return;
    try {
      var target = urgent ? (assertive || (assertive = region('assertive')))
                          : (polite || (polite = region('polite')));
      // clear first so identical consecutive messages still announce
      target.textContent = '';
      target.textContent = text;
    } catch (e) { /* never break the page */ }
  }

  function mirrorNotification(node) {
    // success -> polite; warning/error -> assertive (stock problems are urgent)
    announce((node.textContent || '').trim(), node.classList.contains('warning'));
  }

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('notification')) mirrorNotification(n);
        else if (n.querySelectorAll) {
          var inner = n.querySelectorAll('.notification');
          for (var k = 0; k < inner.length; k++) mirrorNotification(inner[k]);
        }
      }
    }
  });

  function startObserver() {
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }

  /* --- read-only observer for the silent upsell-add failure path ---
     Dedupe rule: if the theme surfaces its OWN notification within
     700ms of a failed /cart/add.js, it has handled the message and we
     stay quiet; only the SILENT failure (frozen theme-level upsell
     handler swallows errors) gets our announcement. Detection compares
     live DOM nodes marked at request time -- immune to MutationObserver
     delivery timing under automation. */
  function markNotifications() {
    var nodes = document.querySelectorAll('.notification');
    for (var i = 0; i < nodes.length; i++) {
      try { nodes[i].__agUxcSeen = true; } catch (e) {}
    }
  }
  function hasFreshNotification() {
    var nodes = document.querySelectorAll('.notification');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__agUxcSeen) return true;
    }
    return false;
  }
  var origFetch = window.fetch;
  if (typeof origFetch === 'function' && !origFetch.__agUxcObserved) {
    var observed = function () {
      var res = origFetch.apply(this, arguments);
      try {
        var url = typeof arguments[0] === 'string' ? arguments[0]
                : (arguments[0] && arguments[0].url) || '';
        var method = (arguments[1] && arguments[1].method) ||
          (arguments[0] && arguments[0].method) || 'GET';
        // Match BOTH /cart/add.js (frozen upsell handler) and /cart/add
        // (product-form's real POST target) -- and their locale-prefixed
        // and query-stringed forms. Matching only the .js spelling made
        // this observer dead on the path customers actually use.
        if (/\/cart\/add(\.js)?(?:[?#]|$)/.test(url) && String(method).toUpperCase() === 'POST') {
          res.then(function (r) {
            if (!r.ok) {
              markNotifications();
              setTimeout(function () {
                if (!hasFreshNotification()) {
                  // theme stayed silent: give an honest, actionable message.
                  announce('Sorry, that item could not be added to the cart. ' +
                    'It may be out of stock. WhatsApp us if you need help.', true);
                }
              }, 700);
            }
          }).catch(function () {});
        }
      } catch (e) { /* read-only: never disturb the request */ }
      return res;
    };
    observed.__agUxcObserved = true;
    window.fetch = observed;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver(); markNotifications();
    });
  } else {
    startObserver(); markNotifications();
  }
})();

/* ------------------------------------------------------------------ *
   R5-Q4: just-added confirmation. The drawer opening IS the desktop
   confirmation, but on a 6-inch screen the new line can sit below the
   fold. When the theme emits ON_ITEM_ADDED we wait for that key's row
   to appear after the AJAX re-render, then give it one calm highlight
   so the customer can see exactly what landed in their cart.
   Purely additive: no cart endpoint touched, no scroll hijack.
   Styles: ag-ux-r5-B4-CART.css §7. Removal: delete this block.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agUxcAddedCue) return;
  window.__agUxcAddedCue = true;

  var pendingKey = null;

  function arm(key) {
    pendingKey = key || null;
    if (!pendingKey) return;
    var deadline = Date.now() + 4000;
    (function look() {
      var node = document.querySelector('.scd-item[data-id="' + pendingKey + '"], ' +
        '.sf-cart__item[data-id="' + pendingKey + '"]');
      if (node) {
        node.classList.remove('aguxc-line-added');
        void node.offsetWidth;
        node.classList.add('aguxc-line-added');
        setTimeout(function () { node.classList.remove('aguxc-line-added'); }, 2400);
        pendingKey = null;
        return;
      }
      if (Date.now() < deadline) setTimeout(look, 120);
    })();
  }

  function hook() {
    if (window.MinimogEvents && typeof window.MinimogEvents.on === 'function') {
      window.MinimogEvents.on('ON_ITEM_ADDED', function (line) {
        arm(line && (line.key || line.id));
      });
      return true;
    }
    return false;
  }
  if (!hook()) {
    // app.js loads before this deferred file in practice, but retry briefly
    var tries = 0;
    var t = setInterval(function () { if (hook() || ++tries > 40) clearInterval(t); }, 150);
  }
})();

/* ------------------------------------------------------------------ *
   R13 coupon field — progressive enhancement for the cart drawer.

   Shopify added the `discount` parameter to /cart/update.js in 2025.
   A rejected code still returns HTTP 200, so success is determined from
   the returned cart's discount applications/allocations, never status alone.
   The existing cart-discounts section remains the visible source of truth;
   it is refreshed after every apply/remove alongside Minimog's cart section.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agCouponR13) return;

  var STORE_KEY = 'ag-r13-coupon-code';
  var state = {
    expanded: false,
    pending: false,
    hydrated: false,
    applied: false,
    code: '',
    saved: 0,
    currency: 'INR',
    message: '',
    tone: '',
    focusAfterRefresh: ''
  };
  var observer = null;
  var installQueued = false;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readStoredCode() {
    try { return window.sessionStorage.getItem(STORE_KEY) || ''; }
    catch (e) { return ''; }
  }

  function storeCode(code) {
    try {
      if (code) window.sessionStorage.setItem(STORE_KEY, code);
      else window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) {}
  }

  function normalize(value) {
    return String(value || '').trim().toUpperCase();
  }

  function amountOf(value) {
    if (value && typeof value === 'object') {
      if (typeof value.amount === 'number') return value.amount;
      if (typeof value.amount === 'string') return Number(value.amount) || 0;
    }
    return Number(value) || 0;
  }

  function applicationTitle(application) {
    if (!application) return '';
    return application.code || application.title ||
      (application.discount_application &&
        (application.discount_application.code || application.discount_application.title)) || '';
  }

  function applicationAmount(application) {
    if (!application) return 0;
    return amountOf(application.total_allocated_amount) ||
      amountOf(application.amount) ||
      amountOf(application.discounted_amount) || 0;
  }

  function matchingApplications(cart, code) {
    var wanted = normalize(code);
    var groups = [];
    var cartLevel = (cart && cart.cart_level_discount_applications) || [];
    var all = (cart && cart.discount_applications) || [];
    var discountCodes = (cart && cart.discount_codes) || [];
    var lineDiscounts = [];
    var allocations = [];
    var items = (cart && cart.items) || [];

    for (var i = 0; i < items.length; i++) {
      lineDiscounts = lineDiscounts.concat(items[i].discounts || []);
      allocations = allocations.concat(items[i].discount_allocations || []);
    }
    groups.push(cartLevel, all, lineDiscounts, allocations);

    var applicableCode = false;
    for (var d = 0; d < discountCodes.length; d++) {
      if (normalize(discountCodes[d].code) === wanted && discountCodes[d].applicable !== false) {
        applicableCode = true;
        break;
      }
    }

    for (var g = 0; g < groups.length; g++) {
      var matches = [];
      for (var j = 0; j < groups[g].length; j++) {
        if (normalize(applicationTitle(groups[g][j])) === wanted) matches.push(groups[g][j]);
      }
      if (matches.length) {
        var saved = 0;
        for (var m = 0; m < matches.length; m++) saved += applicationAmount(matches[m]);
        return { applied: true, saved: saved };
      }
    }
    return { applied: applicableCode, saved: 0 };
  }

  function discountSignature(cart) {
    var out = [];
    var apps = (cart && cart.cart_level_discount_applications) || [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < apps.length; i++) out.push(normalize(applicationTitle(apps[i])));
    for (var j = 0; j < items.length; j++) {
      var discounts = items[j].discounts || [];
      for (var k = 0; k < discounts.length; k++) out.push(normalize(applicationTitle(discounts[k])));
    }
    return out.sort().join('|');
  }

  function formatMoney(cents) {
    var currency = state.currency || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: cents % 100 ? 2 : 0
      }).format(cents / 100);
    } catch (e) {
      return '\u20b9' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
    }
  }

  async function getCart() {
    var response = await window.fetch(rootUrl() + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('CART_READ_FAILED');
    return response.json();
  }

  async function updateDiscount(code) {
    var response = await window.fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    });
    if (!response.ok) throw new Error('DISCOUNT_UPDATE_FAILED');
    /* Shopify serves Ajax Cart JSON as `text/javascript` on this storefront.
       response.json() is the reliable contract; HTML/rate-limit bodies still
       reject here and follow the separate transport-error path. */
    return response.json();
  }

  async function refreshDiscountRenderer() {
    var host = document.querySelector('.ag-cart-drawer [data-discounts]');
    if (!host) return;
    try {
      var response = await window.fetch(rootUrl() + '?section_id=cart-discounts', {
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      });
      if (response.ok) host.innerHTML = (await response.text()).trim();
    } catch (e) {
      /* The full cart refresh below already contains the same Liquid output. */
    }
  }

  async function refreshCartSurfaces(cart) {
    var cartController = window.MinimogTheme && window.MinimogTheme.Cart;
    if (cartController && typeof cartController.renderNewCart === 'function') {
      await cartController.renderNewCart();
    }
    await refreshDiscountRenderer();
    try {
      if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
        window.Shopify.onCartUpdate(cart, false);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (e) {}
  }

  function widgetMarkup() {
    return '' +
      '<button type="button" class="ag-coupon__toggle" aria-expanded="false" aria-controls="ag-coupon-panel" aria-label="Apply discount code. Coupon or offer code.">' +
        '<span class="ag-coupon__toggle-label">' +
          '<span class="ag-coupon__mark" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12 12 20 4 12V4h8z"/><circle cx="9" cy="9" r="1" fill="currentColor" stroke="none"/></svg></span>' +
          '<span class="ag-coupon__toggle-copy"><strong>Apply discount code</strong><small>Coupon or offer code</small></span>' +
        '</span>' +
        '<span class="ag-coupon__toggle-action"><span data-ag-coupon-toggle-action>Enter code</span><svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 3 5 5-5 5"/></svg></span>' +
      '</button>' +
      '<div class="ag-coupon__panel" id="ag-coupon-panel" hidden>' +
        '<form class="ag-coupon__form" novalidate>' +
          '<label class="ag-coupon__label" for="ag-coupon-code">Coupon code</label>' +
          '<div class="ag-coupon__controls">' +
            '<input class="ag-coupon__input" id="ag-coupon-code" name="ag_coupon_code" type="text" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done" maxlength="64" placeholder="Enter code">' +
            '<button class="ag-coupon__apply" type="submit"><span class="ag-coupon__spinner" aria-hidden="true" hidden></span><span data-ag-coupon-apply-label>Apply</span></button>' +
          '</div>' +
        '</form>' +
        '<div class="ag-coupon__applied" hidden>' +
          '<div class="ag-coupon__applied-copy"><span class="ag-coupon__check" aria-hidden="true">\u2713</span><span><strong data-ag-coupon-code></strong><small data-ag-coupon-saving></small></span></div>' +
          '<button type="button" class="ag-coupon__remove">Remove</button>' +
        '</div>' +
        '<p class="ag-coupon__status" role="status" aria-live="polite" aria-atomic="true"></p>' +
      '</div>';
  }

  function updateWidget(widget) {
    if (!widget) return;
    var toggle = widget.querySelector('.ag-coupon__toggle');
    var panel = widget.querySelector('.ag-coupon__panel');
    var form = widget.querySelector('.ag-coupon__form');
    var input = widget.querySelector('.ag-coupon__input');
    var apply = widget.querySelector('.ag-coupon__apply');
    var spinner = widget.querySelector('.ag-coupon__spinner');
    var applied = widget.querySelector('.ag-coupon__applied');
    var remove = widget.querySelector('.ag-coupon__remove');
    var status = widget.querySelector('.ag-coupon__status');

    toggle.setAttribute('aria-expanded', String(state.expanded));
    widget.querySelector('[data-ag-coupon-toggle-action]').textContent = state.expanded ? 'Hide' : 'Enter code';
    panel.hidden = !state.expanded;
    form.hidden = state.applied;
    applied.hidden = !state.applied;
    widget.setAttribute('aria-busy', String(state.pending));

    if (document.activeElement !== input) input.value = state.code || '';
    input.disabled = state.pending;
    apply.disabled = state.pending;
    remove.disabled = state.pending;
    spinner.hidden = !state.pending;
    widget.querySelector('[data-ag-coupon-apply-label]').textContent = state.pending ? 'Checking\u2026' : 'Apply';

    widget.querySelector('[data-ag-coupon-code]').textContent = state.code;
    widget.querySelector('[data-ag-coupon-saving]').textContent = state.saved > 0 ?
      'You saved ' + formatMoney(state.saved) : 'Discount is active';
    remove.setAttribute('aria-label', 'Remove coupon ' + state.code);

    status.textContent = state.message;
    status.dataset.tone = state.tone;
    status.setAttribute('aria-live', state.tone === 'error' ? 'assertive' : 'polite');
  }

  function updateAllWidgets() {
    var widgets = document.querySelectorAll('.ag-cart-drawer [data-ag-coupon]');
    for (var i = 0; i < widgets.length; i++) updateWidget(widgets[i]);
  }

  function removeOwnerHiddenOfferCards() {
    var cards = document.querySelectorAll('.ag-cart-offers__item, .ag-offers-box__item');
    for (var i = 0; i < cards.length; i++) {
      var text = String(cards[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/buy\s*2/i.test(text) && /30%/.test(text)) cards[i].remove();
    }
  }

  function bindWidget(widget) {
    var toggle = widget.querySelector('.ag-coupon__toggle');
    var form = widget.querySelector('.ag-coupon__form');
    var input = widget.querySelector('.ag-coupon__input');
    var remove = widget.querySelector('.ag-coupon__remove');

    toggle.addEventListener('click', function () {
      state.expanded = !state.expanded;
      state.message = '';
      state.tone = '';
      updateAllWidgets();
      if (state.expanded && !state.applied) window.requestAnimationFrame(function () { input.focus(); });
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        state.expanded = false;
        updateAllWidgets();
        toggle.focus();
      }
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (state.pending) return;
      var code = input.value.trim();
      if (!code) {
        state.message = 'Enter a coupon code first.';
        state.tone = 'error';
        updateAllWidgets();
        input.focus();
        return;
      }

      state.pending = true;
      state.code = code;
      state.message = 'Checking this code\u2026';
      state.tone = 'pending';
      updateAllWidgets();

      try {
        var before = await getCart();
        var after = await updateDiscount(code);
        state.currency = after.currency || before.currency || state.currency;
        var result = matchingApplications(after, code);
        var delta = Math.max(0, Number(after.total_discount || 0) - Number(before.total_discount || 0));
        var changed = discountSignature(after) !== discountSignature(before);
        if (!result.applied && changed && delta > 0) result = { applied: true, saved: delta };

        if (!result.applied) {
          state.pending = false;
          state.applied = false;
          state.saved = 0;
          state.message = "That code isn't valid for this cart. It may be expired, mistyped, or not eligible for these items.";
          state.tone = 'error';
          storeCode('');
          updateAllWidgets();
          input.focus();
          return;
        }

        state.pending = false;
        state.applied = true;
        state.saved = result.saved || delta;
        state.message = code + ' applied.' + (state.saved > 0 ? ' You saved ' + formatMoney(state.saved) + '.' : '');
        state.tone = 'success';
        state.focusAfterRefresh = 'remove';
        storeCode(code);
        await refreshCartSurfaces(after);
        installWidget();
      } catch (error) {
        state.pending = false;
        state.applied = false;
        state.saved = 0;
        state.message = "We couldn't check this code right now. Check your connection and try again.";
        state.tone = 'error';
        updateAllWidgets();
        input.focus();
      }
    });

    remove.addEventListener('click', async function () {
      if (state.pending) return;
      state.pending = true;
      state.message = 'Removing coupon\u2026';
      state.tone = 'pending';
      updateAllWidgets();
      try {
        var cart = await updateDiscount('');
        state.pending = false;
        state.applied = false;
        state.saved = 0;
        state.code = '';
        state.message = 'Coupon removed.';
        state.tone = 'success';
        state.focusAfterRefresh = 'input';
        storeCode('');
        await refreshCartSurfaces(cart);
        installWidget();
      } catch (error) {
        state.pending = false;
        state.message = "We couldn't remove this coupon. Please try again.";
        state.tone = 'error';
        updateAllWidgets();
        remove.focus();
      }
    });
  }

  async function hydrateAppliedState() {
    if (state.hydrated) return;
    state.hydrated = true;
    var stored = readStoredCode();
    if (!stored) return;
    try {
      var cart = await getCart();
      var result = matchingApplications(cart, stored);
      if (result.applied) {
        state.code = stored;
        state.saved = result.saved;
        state.currency = cart.currency || state.currency;
        state.applied = true;
        state.expanded = true;
      } else {
        storeCode('');
      }
      updateAllWidgets();
    } catch (e) {}
  }

  function installWidget() {
    installQueued = false;
    removeOwnerHiddenOfferCards();
    var drawer = document.querySelector('.ag-cart-drawer');
    var body = drawer && drawer.querySelector('.scd__body');
    var items = body && body.querySelector('.scd__items');
    if (!drawer || !body || !items) return;

    /* New section renders provide a permanent cart-owned slot after the
       optional care-kit card. The fallbacks keep this asset compatible with
       a stale AJAX section while Liquid and assets roll out together. */
    var slot = body.querySelector('[data-ag-coupon-slot]');
    var careKit = body.querySelector('.ag-cart-upsell');
    var lowestPrices = body.querySelector('.ag-cart-xsell');
    var fallback = body.querySelector('.ag-cart-ordersum');
    var before = lowestPrices || fallback;
    var parent = careKit ? careKit.parentNode : ((before && before.parentNode) || body);

    var widget = drawer.querySelector('[data-ag-coupon]');
    if (!widget) {
      widget = document.createElement('div');
      widget.className = 'ag-coupon';
      widget.setAttribute('data-ag-coupon', '');
      widget.innerHTML = widgetMarkup();
      bindWidget(widget);
    }
    if (slot) {
      if (widget.parentNode !== slot) slot.appendChild(widget);
    } else if (careKit) {
      if (widget.previousElementSibling !== careKit) careKit.insertAdjacentElement('afterend', widget);
    } else if (widget.parentNode !== parent || widget.nextElementSibling !== before) {
      parent.insertBefore(widget, before || null);
    }
    updateWidget(widget);
    hydrateAppliedState();

    if (state.focusAfterRefresh) {
      var selector = state.focusAfterRefresh === 'remove' ? '.ag-coupon__remove' : '.ag-coupon__input';
      state.focusAfterRefresh = '';
      window.requestAnimationFrame(function () {
        var target = document.querySelector('.ag-cart-drawer ' + selector);
        if (target) target.focus();
      });
    }
  }

  function queueInstall() {
    if (installQueued) return;
    installQueued = true;
    window.requestAnimationFrame(installWidget);
  }

  function start() {
    queueInstall();
    if (!observer && document.body) {
      observer = new MutationObserver(queueInstall);
      observer.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:refresh', queueInstall);
    document.addEventListener('cart:updated', queueInstall);
    if (window.MinimogEvents && typeof window.MinimogEvents.on === 'function') {
      window.MinimogEvents.on('ON_OPEN_DRAWER_CART', queueInstall);
    }
  }

  window.__agCouponR13 = { state: state, install: installWidget };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
